import React, { useState } from "react";

import ClusteringTemplate from "../InsightList/Templates/ClusteringTemplate/ClusteringTemplate";
import SliceAndDiceTemplate from "../InsightList/Templates/SliceAndDiceTemplate/SliceAndDiceTemplate";
import { ACCESS_LEVEL, APP_TEMPLATES, ENTITY_TYPES, FLIGHTING_CONSTANTS, routes } from "utility/constants/constants";
import CampaignApp from "../InsightList/Templates/CampaignApp/campaignApp";
import SlidingWindow from "./AppDevTools/SlidingWindow";
import BreadCrumb from "components/shared/Navigation/BreadCrumb";
import useFullscreen from "components/shared/Fullscreen/useFullscreen";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch } from "react-redux";
import swal from "sweetalert";
import * as actions from "redux/actions/AppActions";
import * as commonService from "utility/CommonService.js";

import Tooltip from "@mui/material/Tooltip";
import StarIcon from "@mui/icons-material/Star";
import { EntityMenu } from "components/shared/EntityMenu/EntityMenu";
import { EntityModals } from "components/shared/EntityModals/EntityModals";

export const AppSummaryClickedContext = React.createContext(null);

const App = ({ application, iframe, localURL, user, pinnedApplications }) => {
  const [isPanelOpen, setPanelOpen] = useState(false);
  const [summaryClicked, setSummaryClicked] = useState(false);
  const [showSummaryButton, setShowSummaryButton] = useState(false);
  const history = useHistory();
  const [elementRef, isFullscreen, enterFullscreen, exitFullscreen] = useFullscreen();
  const dispatch = useDispatch();

  // Modal state
  const [showEditModal, setShowEditModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);

  // Derived values
  const canEdit = application.access_level === ACCESS_LEVEL.EDIT;
  const canExec = ACCESS_LEVEL.ALL_EXECUTE.includes(application.access_level);
  const isOwner = application.user_uid === user?.uid;
  const isPinned = pinnedApplications?.find((pin) => pin.id === application.id) ? true : false;

  const handleSummaryClicked = (value) => {
    setSummaryClicked(value)
  }

  const handleShowSummaryButton = (value) => {
    setShowSummaryButton(value)
  }
  const togglePanel = () => {
    setPanelOpen(!isPanelOpen);
  };

  const handlePin = () => {
    dispatch(
      actions.createAppPin({
        body: {
          app_pin: {
            app_id: application.id,
            user_id: user.id,
            pinned: !isPinned,
          },
        },
      })
    ).then((res) => {
      dispatch(
        actions.updatePinnedApps({
          body: {
            app: application,
            pinned: res.value.applicationPinInfo.pinned,
          },
        })
      );
    });
  };

  const handleDelete = () => {
    swal({
      text: "Are you sure you want to delete this insight?",
      className: "logout-alert-modal",
      buttons: [true, "Delete"],
    }).then((result) => {
      if (result) {
        if (isPinned) {
          handlePin();
        }
        const id = application.id;
        const deleteAction = isOwner
          ? actions.deleteApp({ id })
          : actions.deleteAppShare(id);
        dispatch(deleteAction).then((res) => {
          if (res.value && res.value.success) {
            commonService.forSuccess("App Deleted!", "Success");
            history.push(routes.INSIGHTS_LIST);
          }
        });
      }
    });
  };


  return (
    <AppSummaryClickedContext.Provider value={{
      summaryClicked,
      showSummaryButton,
      handleSummaryClicked,
      handleShowSummaryButton
    }}>
      <div className="lds_right_box_wrapper lds_right_po_box_wrapper app-details-wrapper">
        <div className="app_details_header">
          <BreadCrumb
            currentLoc={application.name}
            previousLoc={`${FLIGHTING_CONSTANTS.INSIGHTS} List`}
            goBack={() => history.push(routes.INSIGHTS_LIST)}
          />
          <div className="app_details_actions" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <EntityMenu
              onEdit={canEdit ? () => setShowEditModal(true) : null}
              onShare={canEdit ? () => setShowShareModal(true) : null}
              onLogs={canExec && application.container_name ? togglePanel : null}
              onDelete={handleDelete}
              editLabel="Edit"
              shareLabel="Share"
              logsLabel="Logs"
              deleteLabel="Delete"
              tooltipTitle="More"
            />
            <Tooltip title={isPinned ? "Unpin" : "Pin"} placement="top">
              <StarIcon
                className={isPinned ? "show_pin_app" : "hide_pin_app"}
                onClick={handlePin}
                style={{ cursor: "pointer", color: isPinned ? "#ffd700" : "lightgray" }}
              />
            </Tooltip>
          </div>
        </div>
        <EntityModals
          entity={application}
          entityType={ENTITY_TYPES.APPLICATION}
          updateEntity={actions.updateApp}
          showEditModal={showEditModal}
          setShowEditModal={setShowEditModal}
          showShareModal={showShareModal}
          setShowShareModal={setShowShareModal}
          onShareSuccess={() => dispatch(actions.getApp({ id: application.id }))}
        />        {canExec && application.container_name &&  (
          <SlidingWindow
            isPanelOpen={isPanelOpen}
            onBackdropClicked={togglePanel}
          />
        )}
      <div
      ref={elementRef}
      className={`iframe-container ${isFullscreen ? 'fullscreen' : ''} ${localURL ? 'show' : 'fade'}`}
    >
      {application.app_type === APP_TEMPLATES.CLUSTER ? (
        <ClusteringTemplate application={application} />
      ) : application.app_type === APP_TEMPLATES.SLICEANDDICE ? (
        <SliceAndDiceTemplate application={application} />
      ) : application.app_type === APP_TEMPLATES.CAMPAIGN ? (
        <CampaignApp application={application} />
      ) : (
        <iframe
          src={iframe}
          frameBorder="0"
          title="App"
        ></iframe>
      )}

      <div
        className="fullscreen-toggle-button"
        onClick={isFullscreen ? exitFullscreen : enterFullscreen}
      >
        {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
      </div>
    </div>
      </div>
    </AppSummaryClickedContext.Provider>
  );
};

export default App;
